import React from 'react';
import { FONTS, useRTL } from 'configs/constants';

const FontWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isRTL = useRTL();

  React.useEffect(() => {
    const fontUrl = isRTL ? FONTS.RTL.URL : FONTS.LTR.URL;

    const link = document.createElement('link');
    link.href = fontUrl;
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    document.body.dir = isRTL ? 'rtl' : 'ltr';

    return () => {
      link.remove();
    };
  }, [isRTL]);

  return <>{children}</>;
};

export default FontWrapper;
